import React from 'react';

function CartIcon(props) {
  return (
    <svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3711 9.15808C16.2245 9.15808 14.4798 10.9039 14.4798 13.0504V13.0628H11.3151C11.1227 13.0628 10.9624 13.2148 10.954 13.4088L10.3069 28.0654L10.3069 28.0669C10.3036 28.1626 10.3374 28.2596 10.4075 28.3317C10.476 28.4032 10.5707 28.4431 10.668 28.4431H26.6088C26.7077 28.4431 26.8017 28.4026 26.87 28.331C26.9372 28.2604 26.9733 28.1644 26.97 28.0669L26.3229 13.4096C26.3144 13.2171 26.1546 13.0638 25.9618 13.0638H22.477V13.0504C22.477 10.9039 20.7323 9.15808 18.5858 9.15808H18.3711ZM15.2023 13.0504C15.2023 11.3033 16.624 9.88155 18.3711 9.88155H18.5858C20.3328 9.88155 21.7546 11.3033 21.7546 13.0504V13.0628H15.2023V13.0504ZM11.0458 27.7206L11.661 13.7873H14.4798V16.2202H14.2963C14.0971 16.2202 13.935 16.3822 13.935 16.5814C13.935 16.782 14.0975 16.9426 14.2963 16.9426H15.3858C15.5851 16.9426 15.7471 16.7806 15.7471 16.5814C15.7471 16.3808 15.5846 16.2202 15.3858 16.2202H15.2023V13.7873H21.7546V16.2202H21.571C21.3718 16.2202 21.2098 16.3822 21.2098 16.5814C21.2098 16.782 21.3722 16.9426 21.571 16.9426H22.6606C22.8598 16.9426 23.0218 16.7806 23.0218 16.5814C23.0218 16.3808 22.8594 16.2202 22.6606 16.2202H22.477V13.7873H25.6158L26.2321 27.7206H11.0458Z"
        fill="white"
      />
    </svg>
  );
}

export default CartIcon;
